import Vue from 'vue'
import Main from './toast.vue'

const ToastConstructor = Vue.extend(Main)

let instance;

const Toast = function (text) {
  instance = new ToastConstructor({
    data: {text}
  })
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.visible = true
}

export default Toast



// WEBPACK FOOTER //
// ./src/components/sign/toast.js